import { COUNTRY } from '@mango-engineering/maknet-client-sdk/lib/shop/types';
import { DeliverySlotItem } from '@makro-shopping/price-calculation-service';
import { config } from '../../config/env';
import { DELIVERY_SLOT_DEFAULT_CHANNEL, DELIVERY_SLOT_DEFAULT_STORE } from '../../constants/common';

type GetRealtimeDeliverySlotParams = {
  storeCode: string;
  countryCode: string;
  channel?: string;
  idToken?: string;
};

export type RealtimeDeliverySlotResponse = {
  data: DeliverySlotItem[];
};

export const getRealtimeDeliverySlot = async ({
  storeCode = DELIVERY_SLOT_DEFAULT_STORE,
  countryCode,
  channel = DELIVERY_SLOT_DEFAULT_CHANNEL,
}: GetRealtimeDeliverySlotParams): Promise<RealtimeDeliverySlotResponse | null> => {
  const baseEndpoint = config.SAME_DAY_DELIVERY_SERVICE_URL.replace(/\/$/, '');
  const query = new URLSearchParams({
    store: storeCode,
    channel,
  });
  const endpoint = `${baseEndpoint}/earliest-slot?${query.toString()}`;

  try {
    const response = await fetch(endpoint, {
      method: 'GET',
      headers: {
        Accept: 'application/json, text/plain, */*',
        ...(countryCode === COUNTRY.PHILIPPINES && { 'x-tenant-id': 'makro-ph' }),
      },
    });

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    return await response.json();
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : String(error);
    console.log('Error fetching realtime delivery slot:', message);
    return null;
  }
};
